import { dateFormatter, formatCurrency } from 'commons/utils';

type IColumn = {
  name: string;
  keyValue: string;
  width: string;
  formatValue: (value: string) => string;
};

export const columns: IColumn[] = [
  {
    name: 'Tipo de Figurante',
    keyValue: 'type',
    width: '27.5%',
    formatValue: (value: string) => (value ?? '').toUpperCase(),
  },
  {
    name: 'Quantidade',
    keyValue: 'amount',
    width: '15%',
    formatValue: (value: string) => value,
  },
  {
    name: 'Valor Unitário',
    keyValue: 'unitCost',
    width: '17.5%',
    formatValue: (value: string) => formatCurrency(typeof value === 'number' ? value : Number(value ?? '')),
  },
  {
    name: 'Valor Taxas',
    keyValue: 'taxa',
    width: '15%',
    formatValue: (value: string) => formatCurrency(typeof value === 'number' ? value : Number(value ?? '')),
  },
  {
    name: 'Hora da Apresentação',
    keyValue: 'arrivedTime',
    width: '25%',
    formatValue: (value: string) => dateFormatter(value, 'HH:mm'),
  },
];

export const columnsFiscal: IColumn[] = [
  {
    name: 'Fiscal',
    keyValue: 'type',
    width: '27.5%',
    formatValue: (value: string) => (value ?? '').toUpperCase(),
  },
  {
    name: 'Quantidade',
    keyValue: 'amount',
    width: '15%',
    formatValue: (value: string) => value,
  },
  {
    name: 'Valor Unitário',
    keyValue: 'unitCost',
    width: '17.5%',
    formatValue: (value: string) => formatCurrency(typeof value === 'number' ? value : Number(value ?? '')),
  },
  {
    name: 'Valor Taxas',
    keyValue: 'taxa',
    width: '15%',
    formatValue: (value: string) => formatCurrency(typeof value === 'number' ? value : Number(value ?? '')),
  },
  {
    name: 'Hora da Apresentação',
    keyValue: 'arrivedTime',
    width: '25%',
    formatValue: (value: string) => dateFormatter(value, 'HH:mm'),
  },
];

export const columnsAgency = [
  {
    name: 'Agência',
    keyValue: 'agencyName',
    width: '25%',
    formatValue: (value: string) => value,
  },
];

export const getColumns = (hideAgencyColum = false) => [...columns, ...(!hideAgencyColum ? columnsAgency : [])];
export const getColumnsFiscal = (hideAgencyColum = false) => [...columnsFiscal, ...(!hideAgencyColum ? columnsAgency : [])];

